import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const darkModeAtom = atomWithStorage("darkMode", false);

const mansoryLayoutAtom = atom("");

export { darkModeAtom, mansoryLayoutAtom };
